var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTracks = function SvgTracks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M11.667 12.5H30m-18.333 8.333H30M33.392 5H8.348c-1.722 0-3.13 1.35-3.13 3v27l6.26-6h21.914c1.721 0 3.13-1.35 3.13-3V8c0-1.65-1.409-3-3.13-3Z"
  })));
};
export default SvgTracks;